import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/contacts/ContactsContent.tsx");
